import React from 'react';
import ReactDOM from 'react-dom';
//import { AppContainer } from 'react-hot-loader';
//@ts-ignore
import DI, { store } from 'app';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';
//@ts-ignore
import { flatMessages, locale } from 'app/i18n';
//@ts-ignore
import { IntlProvider } from 'react-intl';

//@ts-ignore
import App from './App';
//@ts-ignore
import apolloClient from './graphql-client';
//@ts-ignore
import BlogWordpressContainer from '@gik/blog/BlogWordpressContainer';
import RelatedArticlesWordpressContainer from '@gik/blog/RelatedArticlesWordpressContainer';
import SingleRowArticleSearchResults from './views/giveinkind/search/SingleRowArticleSearchResults';
import ArticleSearchPageResults from './views/giveinkind/search/ArticleSearchPageResults';
// import InkindPageInformation from './views/giveinkind/inkinds/InkindPageInformation';
import WelcomeScreenContainer from './views/welcome/WelcomeScreenContainer';
import InKindOrganizersContainer from './views/inkind-organizers/InKindOrganizersContainer';
import HomepageTestimonialsContainer from './views/homepage/testimonials/HomepageTestimonialsContainer';
import HomepagePressBarContainer from './views/homepage/press-bar/HomepagePressBarContainer';
import ProductPageContainer from './views/product-page/ProductPageContainer';
import HomepageFeaturedPagesContainer from './views/homepage/featured-pages/HomepageFeaturedPagesContainer';
import ContactContainer from './views/contact/ContactContainer';
import { InkindPage } from '@gik/inkind-page';
import AuthContainer from './views/AuthContainer';
import { ContactPage } from '@gik/contact/components/ContactPage/ContactPage';

import { AppFooter, AppHeader, AppLayout } from '@gik/ui';
import { About } from '@gik/about/components/About/About';
import {
  BenefitsPage,
  CommonQuestionsPage,
  CompetitorsPage,
  FeaturesPage,
  HowItWorksPage,
  TipsSamplePage,
} from '@gik/marketing';
import { Homepage } from '@gik/homepage';
import { UserProfile } from '@gik/user-profile';
import { cache } from '@gik/core/api';
import { syncWithStorage } from '@gik/core/utils/swr-sync-storage';
import { WishlistPage } from '@gik/wishlist-page';
import { NotFoundPage, TermsOfService, PrivacyPolicy } from '@gik/core';
import CreatePage from '@gik/create/components/CreatePage/CreatePage';
import { auth } from '@gik/auth';
import { SupportersPage } from '@gik/crm';

declare const window: LegacyReactWindow;

function WithSWRSyncStorage(props: React.PropsWithChildren<{}>) {
  syncWithStorage(cache, 'session');
  return <>{props.children}</>;
}

function WithAuth(props: React.PropsWithChildren<{}>) {
  React.useEffect(() => {
    auth.autoLogin(window.__root?.userId);
  }, []);

  return <>{props.children}</>;
}

interface IAppLayoutContainerProps {
  inkindRouteId: string;
}

function AppLayoutContainer({ inkindRouteId }: IAppLayoutContainerProps) {
  return (
    <AppLayout>
      {location.pathname === '/' ? (
        <Homepage />
      ) : location.pathname === '/features' ? (
        <FeaturesPage />
      ) : location.pathname === '/benefits' ? (
        <BenefitsPage />
      ) : location.pathname === '/tips-sample-pages' ? (
        <TipsSamplePage />
      ) : location.pathname === '/how-inkind-works' ? (
        <HowItWorksPage />
      ) : location.pathname === '/competitors' ? (
        <CompetitorsPage />
      ) : location.pathname === '/faq' ? (
        <CommonQuestionsPage />
      ) : location.pathname === '/user/profile' ? (
        <UserProfile />
      ) : location.pathname === '/create' ? (
        <CreatePage />
      ) : location.pathname === '/about-us' ? (
        <About hideWhy />
      ) : location.pathname === '/terms-service' ? (
        <TermsOfService />
      ) : location.pathname === '/privacy-policy' ? (
        <PrivacyPolicy />
      ) : location.pathname === '/contact' ? (
        <ContactPage />
      ) : location.pathname.indexOf('/inkinds') >= 0 && location.pathname.indexOf('/wishlist') >= 0 ? (
        <WishlistPage inkindRouteId={inkindRouteId} />
      ) : location.pathname.indexOf('/inkinds') >= 0 && location.pathname.indexOf('/admin/supporters') >= 0 ? (
        <SupportersPage inkindRouteId={inkindRouteId} />
      ) : location.pathname.indexOf('/inkinds') >= 0 ? (
        <InkindPage inkindRouteId={inkindRouteId} />
      ) : (
        <NotFoundPage />
      )}
    </AppLayout>
  );
}

const legacyComponents = {
  BlogWordpressContainer,
  RelatedArticlesWordpressContainer,
  SingleRowArticleSearchResults,
  ArticleSearchPageResults,
  // InkindPageInformation,
  WelcomeScreenContainer,
  InKindOrganizersContainer,
  AuthContainer,
};

const nextComponents = {
  HomepageTestimonialsContainer,
  HomepagePressBarContainer,
  ProductPageContainer,
  HomepageFeaturedPagesContainer,
  ContactContainer,
  AppLayoutContainer,
  AppHeader,
  AppFooter,
};

const components: { [_: string]: React.ReactNode } = {
  ...legacyComponents,
  ...nextComponents,
};

const customHTMLTag = 'create-component';
const componentNameParam = 'type';
const componentPropsParam = 'props-';

const matchComponentNameWithDefinition = (componentName: string): any => {
  return (
    components[componentName] ||
    (() => {
      console.error(`Error: component ${componentName} not found`);
      return () => (
        <div>
          <h1 color="red">Error: component {componentName} not found</h1>
        </div>
      );
    })()
  );
};

const normalizeAttrToPropName = (name: string) =>
  name.replace(componentPropsParam, '').replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });

const decodePropValue = (value: string) => {
  try {
    // In .NET we urlencode the string so that it fits within a single prop value.
    // .NET URLencoding differs from JS and we have to replace +'s manually: see https://stackoverflow.com/questions/17010119/decodeuri-decodes-space-as-symbol
    return JSON.parse(decodeURIComponent(value.replace(/\+/g, ' ')));
  } catch (e) {
    return value;
  }
};

const createComponents = () => {
  console.info('Searching for `create-component` tags...');
  DI.apolloClient = apolloClient;

  // checks whether the page body contains `customHTMLTag` and uses it as the
  // target for rendering react components if present, otherwise searches for actual HTML tags
  const target =
    document.body.getAttribute(customHTMLTag) === null ? document.getElementsByTagName(customHTMLTag) : [document.body];

  Array.prototype.slice.call(target).forEach((componentPlaceholderEl: Element) => {
    const tag = componentPlaceholderEl.getAttribute(componentNameParam);

    const props = Array.prototype.slice
      .call(componentPlaceholderEl.attributes)
      .filter((namedNode: Attr) => {
        return namedNode.name.startsWith(componentPropsParam);
      })
      .reduce((acc: Attr[], current: Attr) => {
        return Object.assign({}, acc, {
          [normalizeAttrToPropName(current.name)]: decodePropValue(current.value),
        });
      }, {});

    const Component = matchComponentNameWithDefinition(tag);

    console.info(`Attaching component "${tag}" to`, componentPlaceholderEl);

    ReactDOM.render(
      <Provider store={store}>
        <IntlProvider key={locale} locale={locale} messages={flatMessages}>
          <ApolloProvider client={apolloClient}>
            <WithSWRSyncStorage>
              <App>
                <WithAuth>
                  <Component {...props} className={legacyComponents[tag] ? 'gik-legacy' : 'gik-next'} />
                </WithAuth>
              </App>
            </WithSWRSyncStorage>
          </ApolloProvider>
        </IntlProvider>
      </Provider>,
      componentPlaceholderEl
    );
  });
};

export default createComponents;
